module.exports = __webpack_public_path__ + "img/img-paddock.90461bcd.jpg";